function normalizeApiBody(res: unknown): Record<string, unknown> {
  if (!res || typeof res !== 'object') {
    return {};
  }

  const record = res as Record<string, unknown>;
  const nested = record.data ?? record.Data;
  if (nested && typeof nested === 'object') {
    const nestedRecord = nested as Record<string, unknown>;
    if ('Success' in nestedRecord || 'success' in nestedRecord) {
      return nestedRecord;
    }
  }

  return record;
}

export class CreateGameRoomError extends Error {
  readonly apiBody: Record<string, unknown>;

  constructor(apiBody: Record<string, unknown>) {
    super('Create game room failed');
    this.name = 'CreateGameRoomError';
    this.apiBody = apiBody;
  }
}

function pickString(data: Record<string, unknown>, ...keys: string[]): string | undefined {
  for (const key of keys) {
    const value = data[key];
    if (value !== undefined && value !== null && value !== '') {
      return String(value);
    }
  }
  return undefined;
}

function pickFromUnknown(data: unknown): string | undefined {
  if (typeof data === 'string' && data.trim()) {
    return data.trim();
  }
  if (!data || typeof data !== 'object') {
    return undefined;
  }

  const record = data as Record<string, unknown>;
  const direct = pickString(record, 'gameRoomId', 'gameRoomID', 'GameRoomId', 'GameRoomID', 'id', 'Id');
  if (direct) return direct;

  for (const nestKey of ['data', 'Data', 'result', 'Result']) {
    const nested = record[nestKey];
    const nestedId = pickFromUnknown(nested);
    if (nestedId) return nestedId;
  }

  return undefined;
}

/** 解析 POST /api/Game/Create 回傳的 gameRoomId（支援 PascalCase / camelCase / 巢狀 Data） */
export function parseCreateGameRoomResponse(res: unknown): string {
  const body = normalizeApiBody(res);
  const success = body.Success ?? body.success;
  if (success === false) {
    throw new CreateGameRoomError(body);
  }

  const data = body.Data ?? body.data ?? body;
  const gameRoomId = pickFromUnknown(data);
  if (!gameRoomId) {
    throw new Error('gameRoomId not found in response');
  }
  return gameRoomId;
}
